export const delay = async (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

export const BASE_URL = `${window.location.protocol}//${window.location.host}`;
